/* global axios */
import ApiClient from '../ApiClient';

// V1 Admin Intelligence Bridge (Part 2) — thin client for the existing
// project.knowledge_base column, exposed via ProjectKnowledgeController.
// No business logic here: read/write only.
class NexceoProjectKnowledgeAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  show(projectId) {
    return axios.get(`${this.url}/${projectId}/knowledge`);
  }

  update(projectId, knowledgeBase) {
    return axios.patch(`${this.url}/${projectId}/knowledge`, {
      knowledge_base: knowledgeBase,
    });
  }

  search(projectId, query) {
    return axios.get(`${this.url}/${projectId}/knowledge/search`, {
      params: { q: query },
    });
  }

  recomputeRoutes(projectId) {
    return axios.post(`${this.url}/${projectId}/knowledge/recompute_routes`);
  }
}

export default new NexceoProjectKnowledgeAPI();
